import {rule} from '@/util/validateRules'
import {getStore} from '@/util/store'
import {SettleType} from '@/const/enum'
import {dicSettleType} from '@/const/dic/settle'

//客户来源数据选择
export const originChannelIdOption = (safe) => {
	return {
		card: true,
		border: true,
		index: false,
		addBtn: false,
		delBtn: false,
		editBtn: false,
		stripe: true,
		menuAlign: 'center',
		searchLabelWidth: 120,
		searchMenuSpan: 12,
		menuWidth: 50,
		searchMenuPosition: 'right',
		labelWidth: 120,
		align: 'center',
		excelBtn: false,
		column: [
			{
				label: '手机号',
				prop: 'mobile',
				search: true,
			},
			{
				label: '微信号',
				hide: true,
				showColumn: false,
				prop: 'wechatNo',
				search: true,
			},
			{
				label: '微信号',
				prop: 'wechatNos',
				type: 'Array',
			},
			{
				label: '客户姓名',
				prop: 'cusName',
			},
			{
				label: '客户昵称',
				prop: 'nickName',
			},
			{
				label: '客户经理',
				prop: 'mainFollowIdName',
			},
		],
	}
}

//留资 选择
export const clueIdListption = (safe) => {
	return {
		card: true,
		border: true,
		index: false,
		addBtn: false,
		delBtn: false,
		editBtn: false,
		stripe: true,
		menuAlign: 'center',
		searchLabelWidth: 120,
		searchMenuSpan: 8,
		menuWidth: 50,
		searchMenuPosition: 'right',
		labelWidth: 120,
		align: 'center',
		excelBtn: false,
		column: [
			{
				label: '手机号',
				prop: 'mobile',
				search: true,
				searchSpan: 8,
				placeholder: '请输入手机号或微信号进行查询',
			},
			{
				label: '微信号',
				prop: 'wxNo',
				search: true,
				hide: true,
				showColumn: false,
				searchSpan: 8,
				placeholder: '请输入手机号或微信号进行查询',
			},

			{
				label: '客户昵称',
				prop: 'nickName',
			},
		],
	}
}
export const listAddOption = {
	submitBtn: false,
	emptyBtn: false,
	labelWidth: 130,
	column: [
		{
			label: '账户状态',
			prop: 'accountType',
			row: true,
			type: 'radio',
			dicData: [
				{
					label: '正式账户',
					value: 1,
				},
				{
					label: '体验账户',
					value: 2,
				},
			],
			value: 1,
			rules: [
				{
					required: true,
					message: '账户状态',
					trigger: 'blur',
				},
			],
		},

		{
			label: '账户类型',
			prop: 'type',
			row: true,
			type: 'radio',
			dicData: [
				{
					label: '个人',
					value: 'INDV',
				},
				{
					label: '机构',
					value: 'INST',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择账户类型',
					trigger: 'blur',
				},
			],
		},
		{
			label: '风险标签',
			prop: 'label',
			row: true,
		},
		{
			label: '微信号',
			prop: 'wechatId',
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入微信号',
				},
				{
					pattern: /^[^\u4e00-\u9fa5]*$/,
					message: '微信号不能包含中文字符',
					trigger: 'blur',
				},
			],
		},
		{
			label: '微信昵称',
			prop: 'wechatNickname',
			span: 12,
		},
		{
			label: '渠道名',
			prop: 'name',
			span: 12,
			value: '（分销）',
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入渠道名称',
				},
				{
					validator: rule.checkSpaceAll,
					trigger: 'blur',
				},
			],
		},
		{
			label: '注册手机',
			prop: 'loginMobile',
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入注册手机',
				},
				{
					min: 11,
					max: 11,
					message: '请输入正确的手机号码',
					trigger: 'blur',
				},
				{
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
			],
		},
		{
			fixed: true,
			label: '联系人',
			span: 12,
			prop: 'contactPerson',
			rules: [
				{
					required: true,
					message: '请输入联系人',
				},
				{
					min: 2,
					max: 10,
					message: '长度在 2 到 10 个字符',
					trigger: 'blur',
				},
			],
		},
		{
			label: '联系手机',
			prop: 'contactPersonMobile',
			rules: [
				{
					required: true,
					message: '请输入联系人手机',
				},
				{
					min: 11,
					max: 11,
					message: '请输入正确的手机号码',
					trigger: 'blur',
				},
				{
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
			],
		},
		{
			label: '渠道地区',
			prop: 'cityCode',
			type: 'cascader',
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicData: [],
			filterable: true,
			emitPath: false,
			rules: [
				{
					required: true,
					message: '请选择渠道地区',
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '业务区域列表',
			prop: 'businessAreas',
			type: 'select',
			multiple: true,
			span: 12,
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicData: [],
			filterable: true,
			// dicUrl: `/dist/area/list/1`,
			rules: [
				{
					required: true,
					message: '请选择业务区域列表',
					trigger: ['blur', 'change'],
				},
			],
			dataType: 'string',
		},
		{
			fixed: true,
			label: '客户列表',
			span: 24,
			disabled: true,
			formslot: true,
			prop: 'crmListStr',
			row: true,
		},
		{
			label: '客户来源方式',
			prop: 'customerSourceType',
			type: 'select',
			span: 12,
			dicData: [
				{
					label: '手动选择',
					value: 'HAND',
				},
				{
					label: '线索关联',
					value: 'CLUE',
				},
			],
			row: true,
			rules: [
				{
					required: true,
					message: '请选择客户来源客户来源方式',
					trigger: ['blur', 'change'],
				},
			],
			dataType: 'string',
		},
		{
			label: '客户线索',
			prop: 'clueLabel',
			disabled: true,
			display: false,
			span: 12,
		},

		{
			label: '客户来源',
			prop: 'customerSource',
			type: 'select',
			display: false,
			// span: 12,
			props: {
				label: 'originSourceName',
				value: 'originSource',
			},
			filterable: true,
			dicUrl: `/dist/distChannel/customerSource `,
			rules: [
				{
					required: true,
					message: '请选择客户来源',
					trigger: ['blur', 'change'],
				},
			],
			dataType: 'string',
		},

		{
			label: '客户来源类型',
			prop: 'customerSourceChannelField',
			display: false,
			type: 'select',
			dicData: [],
			props: {
				label: 'originChanelLabel',
				value: 'customerSourceChannelField',
			},
			filterable: true,
			rules: [
				{
					required: true,
					message: '请选择客户来源渠道类型',
					trigger: ['blur', 'change'],
				},
			],
			dataType: 'string',
		},

		{
			fixed: true,
			label: '客户来源备注',
			span: 24,
			prop: 'customerSourceRemark',
			type: 'textarea',
			maxRows: 5,
			minRows: 3,
		},

		// {
		//   label: "获客方式",
		//   prop: "channelFrom",
		//   type: "select",
		//   span: 24,
		//   dicUrl: `/admin/dict/type/channel_from`,
		//   rules: [
		//     {
		//       required: true,
		//       message: "请选择获客方式",
		//       trigger: ["blur", "change"],
		//     },
		//   ],
		// },
		// {
		//   label: "岗位一姓名",
		//   prop: "channelFromIntroId",
		//   display: false,
		//   type: "select",
		//   filterable: true,
		//   dicUrl: "/dist/distChannel/listContact",
		//   props: {
		//     label: "name",
		//     value: "id",
		//   },
		//   rules: [
		//     {
		//       required: true,
		//       message: "请选择岗位一姓名",
		//       trigger: "blur",
		//     },
		//   ],
		//   dicFormatter: (res) => {
		//     let {data = []} = res;
		//     if (data.length > 0) {
		//       data.forEach((item) => {
		//         let {position = "", name = ""} = item;
		//         item.name = position !== "" ? `${position} -- ${name}` : name;
		//       });
		//     }
		//     return res.data;
		//   },
		// },
		{
			label: '渠道转介绍方式',
			prop: 'channelFromIntro',
			display: false,
			type: 'select',
			dicUrl: '/admin/dict/type/channel_from_intro',
			rules: [
				{
					required: true,
					message: '请选择渠道转介绍方式',
					trigger: 'blur',
				},
			],
		},
		// {
		//   label: "获客来源",
		//   prop: "channelFromWay",
		//   span: 12,
		//   rules: [
		//     {
		//       required: true,
		//       message: "请选择获客来源",
		//       trigger: ["blur", "change"],
		//     },
		//   ],
		//   type: "select",
		//   dicUrl: "/admin/dict/type/channel_from_way",
		// },
		// {
		//   label: "留资线索类型",
		//   prop: "cusWay",
		//   type: "radio",
		//   display: false,
		//   value: 1,
		//   rules: [
		//     {
		//       required: true,
		//       message: "请选择留资线索查询类型",
		//       trigger: ["blur", "change"],
		//     },
		//   ],
		//   control: (val, form) => {
		//     if (val == 2) {
		//       return {
		//         cusId: {
		//           dicUrl: `/dist/distChannel/searchCrmCustomer?wechatNo={{key}}`,
		//           dicFormatter: function ({data = {}}) {
		//             let {records = []} = data;
		//             //如果是微信号查询则显示微信号 cusName -nickName - webchatNos（数组的话、分开）
		//             records = records.map((item) => {
		//               let {
		//                 cusName = "",
		//                 nickName = "",
		//                 wechatNos = [],
		//                 mainFollowIdName,
		//               } = item;
		//               item.label = `${cusName || "空"}-${nickName || "空"}-${wechatNos && wechatNos.length > 0
		//                 ? wechatNos.join("、") : "空"}-客户经理：${mainFollowIdName || "空"}`;
		//               item.value = item.cusId;
		//               return item;
		//             });
		//             return records;
		//           },
		//         },
		//       };
		//     } else {
		//       return {
		//         cusId: {
		//           dicUrl: `/dist/distChannel/searchCrmCustomer?mobile={{key}}`,
		//           dicFormatter: function ({data = {}}) {
		//             let {records = []} = data;
		//             //如果是微信号查询则显示微信号 cusName -nickName - webchatNos（数组的话、分开）
		//             records = records.map((item) => {
		//               let {
		//                 cusName = "",
		//                 nickName = "",
		//                 mobile = "",
		//                 mainFollowIdName,
		//               } = item;
		//               item.label = `${cusName || " "}-${nickName || "空"}-${mobile || "空"
		//               }-客户经理：${mainFollowIdName || "空"}`;
		//               item.value = item.cusId;
		//               return item;
		//             });
		//             return records;
		//           },
		//         },
		//       };
		//     }
		//   },
		//   dicData: [
		//     {
		//       label: "手机号",
		//       value: 1,
		//     },
		//     {
		//       label: "微信号",
		//       value: 2,
		//     },
		//   ],
		// },
		// {
		//   label: "留资线索",
		//   span: 12,
		//   prop: "cusId",
		//   type: "select",
		//   remote: true,
		//   dicUrl: `/dist/distChannel/searchCrmCustomer?mobile={{key}}`,
		//   display: false,

		//   dicFormatter: function ({data = {}}) {
		//     let {records = []} = data;
		//     //如果是微信号查询则显示微信号 cusName -nickName - webchatNos（数组的话、分开）
		//     records = records.map((item) => {
		//       let {
		//         cusName = "",
		//         nickName = "",
		//         mobile = "",
		//         mainFollowIdName,
		//       } = item;
		//       item.label = `${cusName || " "}-${nickName || "空"}-${mobile || "空"
		//       }-客户经理：${mainFollowIdName || "空"}`;
		//       item.value = item.cusId;
		//       return item;
		//     });
		//     return records;
		//   },
		//   rules: [
		//     {
		//       required: true,
		//       message: "请输入选择留资线索",
		//       trigger: ["blur", "change"],
		//     },
		//   ],
		// },
		// {
		//   label: "获客来源备注",
		//   prop: "channelFromWayRemark",
		//   display: false,
		// },
		// {
		//   label: "获客方式工具",
		//   prop: "channelFromTool",
		//   span: 24,
		//   type: "select",
		//   dicUrl: "/admin/dict/type/channel_from_tool",
		// },
		// {
		//   label: "其他来源工具",
		//   prop: "channelFromToolRemark",
		//   display: false,
		// },
		{
			label: '企微沟通群',
			prop: 'weworkGroupId',
			type: 'select',
			remote: true,
			multiple: true,
			dataType: 'string',
			dicUrl: '/dist/distChannel/searchWeworkGroup?name={{key}}',
			value: '',
			props: {
				label: 'name',
				value: 'id',
			},
			dicData: [],
			rules: [
				{
					required: true,
					message: '请选择企微沟通群',
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '渠道业务来源',
			prop: 'businessSource',
			type: 'select',
			rules: [
				{
					required: true,
					message: '请选择业务来源',
					trigger: ['blur', 'change'],
				},
			],
			dicUrl: '/admin/dict/type/channel_business_source',
		},
		{
			label: '主营业务',
			prop: 'mainBusiness',
			type: 'select',
			row: true,
			rules: [
				{
					required: true,
					message: '请选择主营业务',
					trigger: ['blur', 'change'],
				},
			],
			dicUrl: '/admin/dict/type/channel_main_business',
		},
		{
			label: '行业资源',
			prop: 'industryResource',
			span: 24,
			type: 'select',
			rules: [
				{
					required: true,
					message: '请选择行业资源',
					trigger: ['blur', 'change'],
				},
			],
			dicUrl: '/admin/dict/type/channel_industry_resource',
		},
		{
			label: '其他行业资源',
			prop: 'industryResourceRemark',
			display: false,
		},
		{
			label: '渠道属性',
			prop: 'channelAttr',
			type: 'select',
			rules: [
				{
					required: true,
					message: '请选择渠道属性',
					trigger: ['blur', 'change'],
				},
			],
			search: true,
			dicUrl: `/admin/dict/type/channel_attr`,
		},
		{
			label: '备注渠道属性',
			prop: 'channelAttrRemark',
		},
		{
			label: '展业模式',
			prop: 'businessModel',
			type: 'select',
			span: 24,
			rules: [
				{
					required: true,
					message: '请选择展业模式',
					trigger: ['blur', 'change'],
				},
			],
			dicUrl: '/admin/dict/type/channel_business_model',
		},
		{
			label: '服务类型',
			prop: 'serviceType',
			type: 'select',
			display: false,
			rules: [
				{
					required: true,
					message: '请选择服务类型',
					trigger: 'blur',
				},
			],
			dicUrl: '/admin/dict/type/channel_service_type',
		},
		{
			label: '其他服务类型',
			prop: 'serviceTypeRemark',
			display: false,
		},
		{
			label: '渠道开设联系人',
			prop: 'contactId',
			type: 'select',
			filterable: true,
			props: {
				label: 'name',
				value: 'id',
			},
			rules: [
				{
					required: true,
					message: '请选择渠道开设联系人',
					trigger: ['blur', 'change'],
				},
			],
			dicUrl: '/dist/distChannel/listContact',
		},
		{
			label: '业务跟进人',
			prop: 'followId',
			type: 'select',
			filterable: true,
			props: {
				label: 'name',
				value: 'id',
			},
			rules: [
				{
					required: true,
					message: '请选择业务跟进人',
					trigger: ['blur', 'change'],
				},
			],
			dicUrl: '/dist/distChannel/follow/listContact',
		},
		{
			label: '首次获客时间',
			prop: 'acquireTime',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			rules: [
				{
					required: true,
					message: '请选择首次获客时间',
					trigger: 'blur',
				},
			],
		},
		{
			label: '结算账号类型',
			prop: 'settleMethod',
			type: 'select',
			value: 'NORMAL',
			clearable: false,
			dicData: [
				{
					label: '常规',
					value: 'NORMAL',
				},
				{
					label: '双轨',
					value: 'DUAL',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择结算账号类型',
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '基础方案',
			prop: 'ruleBasicId',
			type: 'select',
			props: {
				label: 'name',
				value: 'id',
			},
			clearable: false,
			dicData: [],
		},
		{
			label: '奖励方案',
			prop: 'ruleAwardIds',
			type: 'select',
			row: true,
			span: 24,
			filterable: true,
			multiple: true,
			props: {
				label: 'name',
				value: 'id',
			},
			dicData: [],
		},
		{
			label: '自动结算',
			prop: 'autoSettle',
			type: 'radio',
			value: '0',
			display: false,
			dicData: [
				{
					label: '开启',
					value: '1',
				},
				{
					label: '关闭',
					value: '0',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择是否自动结算',
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '结算方式',
			prop: 'settleType',
			type: 'radio',
			display: false,
			dicData: dicSettleType,
			rules: [
				{
					required: true,
					message: '请选择结算方式',
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '结算周期',
			prop: 'settlePeriod',
			disabled: false,
			type: 'radio',
			display: false,
			value: 'MONTH',
			dicData: [
				{
					label: '月结',
					value: 'MONTH',
				},
				{
					label: '半月结',
					value: 'SEMI_MONTH',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择结算周期',
					trigger: ['change'],
				},
			],
		},
		// settleTaxRate select 1%、3%、6%
		{
			label: '结算税点',
			prop: 'settleTaxRate',
			type: 'select',
			display: false,
			disabled: false,
			dicData: [],
			rules: [
				{
					required: true,
					message: '请选择结算税点',
					trigger: ['blur', 'change'],
				},
			],
		},
		//settleRemitAccount select MB 美保，MBJJ 美保经纪，LG 蓝工科技
		{
			label: '结算打款账户',
			prop: 'settleRemitAccount',
			type: 'select',
			display: false,
			disabled: false,
			dicData: [
				{
					label: '广州美保科技有限公司',
					value: 'MB',
				},
				{
					label: '广东美保保险经纪有限公司',
					value: 'MBJJ',
				},
				{
					label: '蓝工科技',
					value: 'LG',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择结算打款账户',
					trigger: ['blur', 'change'],
				},
			],
		},
		//合同开始时间 contractStartTime
		// 合同结束时间 contractEndTime
		{
			label: '合同开始时间',
			prop: 'contractStartTime',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			display: false,
		},
		{
			label: '合同结束时间',
			prop: 'contractEndTime',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			display: false,
		},
		{
			//对公数据
			label: '是否含税',
			prop: 'settleTaxFlag',
			type: 'radio',
			display: false,
			dicData: [
				{
					label: '是',
					value: '1',
				},
				{
					label: '否',
					value: '0',
				},
			],
		},
		//多文件上传
		{
			label: '合同附件',
			prop: 'settleProtocols',
			type: 'upload',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				url: 'url',
				name: 'name',
				res: 'data',
			},
			dataType: 'string',
			dragFile: true,
			row: true,
			fileSize: 8 * 1024,
			display: false,
		},
		{
			label: '',
			labelWidth: 0,
			formslot: true,
			span: 24,
			prop: 'settlePerson',
		},

		{
			label: '理赔跟进方式',
			prop: 'claimsWay',
			multiple: true,
			dataType: 'string',
			type: 'select',
			dicData: [
				{
					label: '客户自行理赔',
					value: 'CUSTOMERS_CLAIMS',
				},
				{
					label: '下级业务员各自跟进',
					value: 'SALESMAN_FOLLOW',
				},
				{
					label: '渠道统一跟进',
					value: 'CHANNEL_FOLLOW',
				},
			],
		},
		{
			label: '理赔联系人电话',
			prop: 'claimsContactMobile',
			rules: [
				{
					min: 11,
					max: 11,
					message: '请输入正确的手机号码',
					trigger: 'blur',
				},
				{
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
			],
		},

		{
			label: '理赔联系人身份',
			prop: 'claimsContactIdentity',
			type: 'select',
			display: true,
			filterable: true,
			dataType: 'number',
			dicUrl: '/dist/distChannel/get/claimsContactIdentity',
			props: {
				label: 'name',
				value: 'value',
			},
		},
		{
			label: '理赔联系人称呼',
			prop: 'claimsContactName',
			display: true,
		},

		{
			label: '备注',
			prop: 'remark',
			type: 'textarea',
			display: true,
			span: 24,
			showWordLimit: true,
			maxlength: 200,
			minRows: 3,
			maxRows: 5,
		},
		{
			label: '状态',
			prop: 'status',
			type: 'switch',
			value: 0,
			display: true,
			disabled: false,
			span: 12,
			dicData: [
				{
					label: '停用',
					value: 0,
				},
				{
					label: '启用',
					value: 1,
				},
				{
					label: '待审核',
					value: 4,
				},
				
			],
		},
		{
			label: '投保状态',
			prop: 'insureAuthority',
			type: 'select',
			disabled: false,
			display: false,
			span: 12,
			dicData: [
				{
					label: '全部可用',
					value: 'ALL',
				},
				{
					label: '禁止新保(可替换与新增)',
					value: 'OLD',
				},
				{
					label: '禁止新保和新增(可替换)',
					value: 'REPLACE',
				},
			],
			rules: [
				{
					required: true,
					message: '请选择停用状态',
					trigger: ['blur', 'change'],
				},
			],
			control: (val, form) => {
				return {
					insureAuthorityExpireTime: {
						display: val === 'OLD' || val === 'REPLACE',
					},
				}
			},
		},
		{
			label: '起保时间延期',
			prop: 'insureStartDays',
			placeholder: '请输入天数',
			disabled: false,
			type: 'number',
			append: '天数',
			min: 0,
			max: 100,
		},
		{
			label: '到期时间',
			prop: 'insureAuthorityExpireTime',
			disabled: false,
			display: true,
			type: 'datetime',
			format: 'yyyy-MM-dd 23:59:59',
			valueFormat: 'yyyy-MM-dd 23:59:59',
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
				},
			},
			row: true,
			placeholder: '请选择 到期时间(不选，则永久禁止！)',
		},
		{
			label: '可用产品',
			prop: 'insureTypes',
			type: 'checkbox',
			dataType: 'string',
			//内容长则隐藏
			overHidden: true,
			span: 5,
			dicData: getStore({name: 'insureTypes'}),
			props: {
				label: 'name',
				value: 'type',
			},
			rules: [
				{
					required: true,
					message: '请选择可用产品',
					trigger: ['blur', 'change'],
				},
			],
		},
		{
			label: '（泛高空专用）限制小额对公支付',
			prop: 'limitPublicPay',
			type: 'switch',
			value: 'ON',
			labelWidth: 250,
			display: true,
			disabled: false,
			span: 24,
			dicData: [
				{
					label: '关闭',
					value: 'OFF',
				},
				{
					label: '开启',
					value: 'ON',
				},
			],
		},
		{
			label: '限制创建子渠道',
			prop: 'limitAddChannel',
			type: 'switch',
			value: 0,
			labelWidth: 250,
			display: true,
			disabled: false,
			span: 24,
			dicData: [
				{
					label: '关闭',
					value: 0,
				},
				{
					label: '开启',
					value: 1,
				},
			],
		},
		{
			label: '限制创建内勤账号',
			prop: 'limitAddAccount',
			type: 'switch',
			value: 0,
			labelWidth: 250,
			display: true,
			disabled: false,
			span: 24,
			dicData: [
				{
					label: '关闭',
					value: 0,
				},
				{
					label: '开启',
					value: 1,
				},
			],
		},
		{
			label: '创建时间',
			prop: 'createdAt',
			type: 'datetime',
			display: true,
			disabled: true,
		},
	],
}

export const listAddOptionPrivate = {
	submitBtn: false,
	emptyBtn: false,
	menu: false,
	labelWidth: 110,
	column: [
		{
			label: '结算人',
			prop: 'userName',
			disabled: false,
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 结算人姓名',
					trigger: 'blur',
				},
				{
					min: 2,
					max: 10,
					message: '长度在 2 到 10 个字符',
					trigger: 'blur',
				},
			],
		},
		{
			label: '联系手机',
			prop: 'mobile',
			rules: [
				{
					min: 11,
					max: 11,
					required: true,
					message: '请输入 结算人手机号',
					trigger: 'blur',
				},
				{
					message: '请输入正确的手机号',
					validator: rule.validatorMobile,
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证号',
			prop: 'idNo',
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 身份证号',
					trigger: 'blur',
				},
				{
					validator: rule.validatorIdNo,
					trigger: 'blur',
				},
			],
		},
		{
			label: '开户行',
			prop: 'bankName',
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 开户行信息',
					trigger: 'blur',
				},
			],
		},
		{
			label: '银行卡号',
			prop: 'cardNo',
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 银行卡号',
					trigger: 'blur',
				},
				{
					validator: rule.validatorNumber,
					trigger: 'blur',
				},
			],
		},
		{
			label: '开户地',
			type: 'cascader',
			prop: 'bankCity',
			emitPath: false,
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			dicUrl: `/dist/area/list/2`,
			dicMethod: 'get',
			filterable: true,
			showAllLevels: true,
			rules: [
				{
					required: true,
					message: '请选择 开户地',
					trigger: 'blur',
				},
			],
		},
		{
			label: '',
			prop: 'del',
			formslot: true,
		},
	],
}

export const listAddOptionPublic = {
	submitBtn: false,
	emptyBtn: false,
	menu: false,
	labelWidth: 130,
	column: [
		{
			label: '企业全称',
			prop: 'userName',
			disabled: false,
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 企业全称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '开户行',
			prop: 'bankName',
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 开户行',
					trigger: 'blur',
				},
			],
		},
		{
			label: '银行卡号',
			prop: 'cardNo',
			span: 12,
			rules: [
				{
					required: true,
					message: '请输入 银行卡号',
					trigger: 'blur',
				},
			],
		},
		{
			label: '是否发邮件',
			prop: 'emailFlag',
			type: 'radio',
			dicData: [
				{
					label: '是',
					value: '1',
				},
				{
					label: '否',
					value: '0',
				},
			],
			control: (value, form) => {
				return {
					email: {
						display: value === '1',
					},
				}
			},
			rules: [
				{
					required: true,
					message: '请选择 是否发邮件',
					trigger: 'blur',
				},
			],
		},
		{
			label: '邮箱',
			prop: 'email',
			display: true,
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入邮箱',
					trigger: 'blur',
				},
			],
		},
		{
			label: '',
			prop: 'del',
			formslot: true,
		},
	],
}

//处理税点的dic
export const settleTaxRateDicList = {
	[SettleType.PUBLIC]: [
		{
			label: '1%',
			value: 100,
		},
		{
			label: '3%',
			value: 300,
		},
		{
			label: '6%',
			value: 600,
		},
		{
			label: '6.5%',
			value: 650,
		},
	],
	[SettleType.AGENT]: [
		{
			label: '5%',
			value: 500,
		},
	],
	[SettleType.PRIVATE]: [],
	[SettleType.INTER]: [
		{
			label: '6%',
			value: 600,
		},
	],
}
